import { render, staticRenderFns } from "./veStuHealthAskMy.vue?vue&type=template&id=20ffa29a&scoped=true"
import script from "./veStuHealthAskMy.vue?vue&type=script&lang=js"
export * from "./veStuHealthAskMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ffa29a",
  null
  
)

export default component.exports